import { render, staticRenderFns } from "./ButtonOutline.vue?vue&type=template&id=e979f04c&"
import script from "./ButtonOutline.vue?vue&type=script&lang=js&"
export * from "./ButtonOutline.vue?vue&type=script&lang=js&"
import style0 from "./ButtonOutline.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CImage: require('@chakra-ui/vue').CImage, CText: require('@chakra-ui/vue').CText, CButton: require('@chakra-ui/vue').CButton, CBox: require('@chakra-ui/vue').CBox})
